import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly STORAGE_KEY = 'sorrus_guid';
  private readonly USER_EMAIL_KEY = 'sorrus_user_email';
  private readonly USER_2FA_KEY = 'sorrus_user_2fa';
  private readonly FAILED_ATTEMPTS_KEY = 'sorrus_failed_attempts';
  private readonly LOCKOUT_KEY = 'sorrus_lockout_until';
  private readonly LAST_EMAIL_KEY = 'sorrus_last_email';
  
  // THE MASTER KEY
  private readonly MASTER_GUID = 'd6c7b9a1-e2f3-4a5b-8c9d-0e1f2a3b4c5d';
  private readonly MAX_ATTEMPTS = 5;
  private readonly LOCKOUT_TIME = 15 * 60 * 1000; // 15 minutes in ms

  login(guid: string, email?: string, code?: string): { success: boolean, message?: string } {
    const lockoutUntil = localStorage.getItem(this.LOCKOUT_KEY);
    if (lockoutUntil && Date.now() < parseInt(lockoutUntil)) {
      const minutesLeft = Math.ceil((parseInt(lockoutUntil) - Date.now()) / 60000);
      return { success: false, message: `Zu viele Versuche. Bitte warten Sie ${minutesLeft} Minuten.` };
    }

    // Static master key logic (legacy)
    if (guid === this.MASTER_GUID && !email) {
      localStorage.setItem(this.STORAGE_KEY, guid);
      localStorage.removeItem(this.USER_EMAIL_KEY);
      localStorage.removeItem(this.USER_2FA_KEY);
      localStorage.removeItem(this.FAILED_ATTEMPTS_KEY);
      localStorage.removeItem(this.LOCKOUT_KEY);
      return { success: true };
    }

    // Multi-user logic
    if (guid && email) {
      localStorage.setItem(this.STORAGE_KEY, guid);
      localStorage.setItem(this.USER_EMAIL_KEY, email);
      localStorage.setItem(this.USER_2FA_KEY, code || '');
      localStorage.setItem(this.LAST_EMAIL_KEY, email); // Save for next time
      return { success: true };
    }

    // Failed attempt logic
    let attempts = parseInt(localStorage.getItem(this.FAILED_ATTEMPTS_KEY) || '0');
    attempts++;
    localStorage.setItem(this.FAILED_ATTEMPTS_KEY, attempts.toString());

    if (attempts >= this.MAX_ATTEMPTS) {
      const lockUntil = Date.now() + this.LOCKOUT_TIME;
      localStorage.setItem(this.LOCKOUT_KEY, lockUntil.toString());
      return { success: false, message: 'Maximale Versuche erreicht. System für 15 Minuten gesperrt.' };
    }

    return { success: false, message: `Falsche Zugangsdaten. Noch ${this.MAX_ATTEMPTS - attempts} Versuche.` };
  }

  logout() {
    localStorage.removeItem(this.STORAGE_KEY);
    localStorage.removeItem(this.USER_EMAIL_KEY);
    localStorage.removeItem(this.USER_2FA_KEY);
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem(this.STORAGE_KEY);
  }

  getGuid(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  getUserEmail(): string | null {
    return localStorage.getItem(this.USER_EMAIL_KEY);
  }

  get2faCode(): string | null {
    return localStorage.getItem(this.USER_2FA_KEY);
  }

  set2faCode(code: string) {
    localStorage.setItem(this.USER_2FA_KEY, code);
  }

  getLastEmail(): string {
    return localStorage.getItem(this.LAST_EMAIL_KEY) || '';
  }
}
